import { useStatic } from 'context/StaticDataProvider/index';
import { useReducerData } from 'store/hooks';
import uniqBy from 'lodash/uniqBy';

const useDesktopReviewFilters = () => {
  const { getData } = useStatic();
  const exportMarket = getData('exportMarket');
  const desktopReviewFilters = useReducerData('desktopReview', 'desktopReviewFilters.data', {});
  const jobOwnerOptions = (desktopReviewFilters?.jobOwner || []).map((obj) => ({
    value: obj.id,
    label: obj.name,
    type: obj.type,
  }));
  const reviewedByOptions = uniqBy(
    (desktopReviewFilters?.reviewedBy || []).map((obj) => ({
      value: obj.id,
      label: obj.name,
      type: obj.type,
    })),
    'value'
  );
  const shareToOptions = (desktopReviewFilters?.shareTo || []).map((obj) => ({
    value: obj.id,
    label: obj.name,
    type: obj.type,
  }));
  const uploadedByOptions = (desktopReviewFilters?.uploadedBy || []).map((obj) => ({
    value: obj.id,
    label: obj.name,
    type: obj.type,
  }));
  const categoryOptions = (desktopReviewFilters?.categories || []).map((obj) => ({
    value: obj.id,
    label: obj.name,
    type: obj.type,
  }));

  const exportMarketOptions = (exportMarket || []).map((obj) => ({
    value: obj.countryCode,
    label: obj.name,
  }));

  return {
    jobOwnerOptions,
    reviewedByOptions,
    shareToOptions,
    uploadedByOptions,
    categoryOptions,
    exportMarketOptions,
  };
};

export default useDesktopReviewFilters;
